import type { RasterLayerSource } from '@/hooks/useDatasets';
import { releaseTilesPath } from '@/views/map/layers/releaseTiles';
import type { LayerConfig } from '@/views/map/layers/types';
import { LayerType } from '@/views/map/layers/types';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { GL } from '@luma.gl/constants';
import { WTA_COLOR_MAP } from './utils';
import { getGeoBoundingBox } from '@/views/map/utils';

export const getWorktypeAnalysisLayer = (
  source: RasterLayerSource,
  config: LayerConfig,
  isOverview = true,
  minZoom = 14,
  maxZoom = 24
) => {
  const cmap_param = encodeURIComponent(JSON.stringify(WTA_COLOR_MAP));
  return new TileLayer({
    id: LayerType[LayerType.worktype_analysis],
    data: `${releaseTilesPath(source, 'png')}?pixel_selection=first&return_mask=true&bidx=1&resampling=nearest&colormap=${cmap_param}&tilesize=256`,
    minZoom,
    maxZoom,
    opacity: isOverview ? 0.25 : 0.15,
    pickable: true,
    refinementStrategy: 'no-overlap',
    ...config,
    renderSubLayers: (props) => {
      if (props.data === null) {
        return null;
      }

      const boundingBox = getGeoBoundingBox(props);
      if (!boundingBox) {
        return null;
      }
      const { west, south, east, north } = boundingBox;

      return new BitmapLayer({
        id: props.id,
        image: props.data,
        bounds: [west, south, east, north],
        textureParameters: {
          [GL.TEXTURE_MIN_FILTER]: GL.NEAREST,
          [GL.TEXTURE_MAG_FILTER]: GL.NEAREST,
        },
        transparentColor: [255, 255, 255, 0],
        pickable: props.pickable,
        opacity: props.opacity,
        visible: props.visible,
        highlightColor: props.highlightColor,
      });
    },
  });
};
